import { FC } from 'react';

import { H1 } from 'bloko/blocks/header';

import TechnicalWorks from 'src/components/TechnicalWorks';
import { useSelector } from 'src/modules/useSelector';

const MaintenanceMessage: FC = () => {
    const maintenance = useSelector((state) => state.maintenanceTillDatetime);

    return <TechnicalWorks TitleElement={H1} date={maintenance?.date} time={maintenance?.time} />;
};

export default MaintenanceMessage;
